import React, { useState, useEffect, ReactNode } from 'react'
import { Button } from '@blueprintjs/core'
import { Flex, Icon, Popover } from '@ui'
import { Popover2Props } from '@blueprintjs/popover2'
interface Props extends Popover2Props {
  children?: any
  enabled?: boolean
  text: string | React.ReactNode
  track?: () => void
  onConfirm: () => Promise<any> | void
  onCancel?: () => Promise<any> | void
  shouldHide?: boolean
  cancelable?: boolean
  confirmButtonText?: string
  cancelButtonText?: string
  noIcon?: boolean
}

export default function Confirmation({
  children,
  enabled = true,
  text,
  onConfirm,
  onCancel,
  cancelable,
  shouldHide,
  track,
  confirmButtonText,
  cancelButtonText,
  noIcon,
  ...popoverProps
}: Props) {
  const [loading, setLoading] = useState(false)
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    if (shouldHide) {
      setLoading(false)
      setIsOpen(false)
    }
  }, [shouldHide])

  if (!enabled) return children

  return (
    <Popover
      minimal
      usePortal
      canEscapeKeyClose
      isOpen={isOpen}
      onOpened={() => track && track()}
      onClose={() => setIsOpen(false)}
      {...popoverProps}
      content={
        <div style={{ padding: 10 }}>
          <Flex
            align="center"
            style={{
              padding: '10px 0',
              fontSize: 15,
              color: 'var(--black)',
              whiteSpace: 'nowrap',
            }}
          >
            {!noIcon && (
              <Icon name="exclamation-triangle" style={{ marginRight: 10, color: 'var(--red)' }} />
            )}
            {text}
          </Flex>
          <Flex>
            <Button
              data-button="yes"
              fill
              style={{ marginTop: 8 }}
              loading={loading}
              onClick={() => {
                setLoading(true)
                const promise: Promise<any> | void = onConfirm()
                if (promise && 'catch' in promise) {
                  promise
                    .then(() => {
                      setIsOpen(false)
                      setLoading(false)
                    })
                    .catch(() => {
                      setIsOpen(false)
                      setLoading(false)
                    })
                } else {
                  setLoading(false)
                }
              }}
            >
              {confirmButtonText || 'Yes'}
            </Button>
            {!!cancelable && (
              <Button
                className="ml2"
                fill
                style={{ marginTop: 8 }}
                onClick={() => {
                  onCancel && onCancel()
                  setIsOpen(false)
                }}
              >
                {cancelButtonText || 'No'}
              </Button>
            )}
          </Flex>
        </div>
      }
    >
      <div onClick={() => setIsOpen(true)}>{children}</div>
    </Popover>
  )
}
